<ng-template #contentHeaderTemplate></ng-template>

<app-table id="dashboard.time-tracking.absence-requests.absences.index"></app-table>
